// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"e42508da","453":"11573aaf","626":"1d1d445f"}[chunkId] + ".chunk.js";
};